'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var PropTypes = require('prop-types');
var FontIcon = require('./FontIcon.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');
require('@babel/runtime/helpers/defineProperty');
require('deepmerge');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var StyledToolTip = /*#__PURE__*/react.styled('div')({
  name: "StyledToolTip",
  "class": "sb0qj37",
  propsAsIs: false
});

({
  /** Content to put inside of the tooltip */
  content: PropTypes__default["default"].string.isRequired,
  /** Which direction to offset the tooltip from the icon */
  offset: PropTypes__default["default"].string.isRequired,
  /** Name of the icon to use. This generates the icon */
  iconName: PropTypes__default["default"].string.isRequired,
  /** Additional classes to pass to the component */
  className: PropTypes__default["default"].string,
  /** Mouseover event handler */
  onMouseOver: PropTypes__default["default"].func
});
var ToolTip = function ToolTip(_ref) {
  var content = _ref.content,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 'center' : _ref$offset,
    className = _ref.className,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'information-circle' : _ref$iconName,
    onMouseOver = _ref.onMouseOver;
  var id = content.split(' ').join('-').substring(0, 30);
  return /*#__PURE__*/jsxRuntime.jsx(StyledToolTip, {
    className: className === null ? undefined : className,
    onMouseOver: onMouseOver ? function (e) {
      return onMouseOver(e);
    } : undefined,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      role: "tooltip",
      id: id,
      "data-tooltip": content,
      "data-offset": offset,
      children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
        iconName: iconName,
        "aria-describedby": id
      })
    })
  });
};

exports["default"] = ToolTip;
